<template>
  <el-container>
    <el-main>
      <el-row
        type="flex"
        justify="space-start"
        :gutter="20"
      >
        <el-col :span="8">
          <el-card>
            <div class="card-header">
              <h4 class="title">Add a new promotion</h4>
              <p class="category">Enter new promotion details below</p>
              <br>
            </div>
            <div class="card-content">
              <el-form :model="promotion" :rules="rules" ref="promotion" label-width="120px">
                <el-row>

                  <el-form-item label="Code" prop="code">
                    <el-input
                      type="text"
                      label="Code"
                      placeholder="Code"
                      v-model="promotion.code"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Description" prop="description">
                    <el-input
                      type="text"
                      label="Description"
                      placeholder="Description"
                      v-model="promotion.description"
                    ></el-input>
                  </el-form-item>

                  <h5>Discount settings</h5>

                  <el-form-item label="Products" prop="type">
                    <el-select
                      size="large"
                      class="form-group border-input"
                      placeholder="Products"
                      v-model="promotion.type"
                    >
                      <el-option
                        v-for="option in promotionTypes"
                        :value="option"
                        :label="option"
                        :key="option"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <div v-if="promotion.type == 'selected classrooms'">

                    <el-form-item label="Start Date" prop="startFilter">
                      <el-date-picker
                        v-model="startFilter"
                        type="datetime"
                        placeholder="Select date and time"
                        @change="getClassrooms()">
                      </el-date-picker>
                    </el-form-item>

                    <el-form-item label="End Date" prop="endFilter">
                      <el-date-picker
                        v-model="endFilter"
                        type="datetime"
                        placeholder="Select date and time"
                        @change="getClassrooms()">
                      </el-date-picker>
                    </el-form-item>

                    <el-form-item label="Classrooms" prop="type">
                      <el-select
                        size="large"
                        class="form-group border-input"
                        placeholder="Selected Classrooms"
                        multiple
                        filterable
                        style="width:100%;"
                        v-model="selectedClassRooms"
                      >
                        <el-option
                          v-for="option in classrooms"
                          :value="option.id"
                          :label="option.startDate +' in '+ option.venue.town + ' for ' + option['length'] + ' days'"
                          :key="option.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>  
                  </div>

                  <div v-if="promotion.type == 'selected courses' || promotion.type == 'combination'">
                    <el-form-item label="Select Courses" prop="type">
                      <el-select
                        size="large"
                        class="form-group border-input"
                        multiple
                        filterable
                        style="width:100%;"
                        placeholder="Select Courses"
                        v-model="selectedProducts"
                      >
                        <el-option
                          v-for="option in courses"
                          :value="option.id"
                          :label="option.name"
                          :key="option.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>  
                  </div>
                  
                  <el-form-item label="Discount Type" prop="calculationType">
                    <el-select
                      size="large"
                      class="form-group border-input"
                      placeholder="Discount Type"
                      v-model="promotion.calculationType"
                    >
                      <el-option
                        v-for="option in calculationTypes"
                        :value="option"
                        :label="option"
                        :key="option"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="Amount" prop="amount" v-if="promotion.calculationType == 'flat first'">
                    <el-input
                      type="number"
                      label="Amount"
                      placeholder="Amount"
                      v-model="promotion.discountFlat"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Amount" prop="amount" v-if="promotion.calculationType == 'percentage first'">
                    <el-input
                      type="number"
                      label="Amount"
                      placeholder="Amount"
                      v-model="promotion.discountPercentage"
                    ></el-input>
                  </el-form-item>

                  <h5>Uses</h5>

                  <el-form-item label="Is Infinite" prop="isInfinite">
                    <el-checkbox 
                      :checked="promotion.isInfinite==1?true:false"  
                      v-model="promotion.isInfinite">
                    </el-checkbox>
                  </el-form-item>

                  <el-form-item label="Max Uses" prop="maxUses">
                    <el-input
                      type="text"
                      label="Max Uses"
                      :disabled="promotion.isInfinite==1"
                      placeholder="Max Uses"
                      v-model="promotion.maxUses"
                    ></el-input>
                  </el-form-item>

                  <h5>Duration</h5>

                  <el-form-item label="Forever" prop="neverEnding">
                    <el-checkbox 
                      :checked="promotion.neverEnding==1?true:false"  
                      v-model="promotion.neverEnding">
                    </el-checkbox>
                  </el-form-item>

                  <el-form-item label="Start Date" prop="startDate">
                    <el-date-picker
                      v-model="promotion.startDate"
                      :disabled="promotion.neverEnding==1"
                      type="datetime"
                      placeholder="Select date and time">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="End Date" prop="endDate">
                    <el-date-picker
                      v-model="promotion.endDate"
                      :disabled="promotion.neverEnding==1"
                      type="datetime"
                      placeholder="Select date and time">
                    </el-date-picker>
                  </el-form-item>

                </el-row>
                <el-form-item>
                  <el-button type="success" v-on:click.prevent="addPromotion()">Add promotion</el-button>
                </el-form-item>
              </el-form>
            </div>
            <el-dialog title="Confirm Delete" :visible.sync="dialogVisible" width="30%" :modal="false">
              <span>This will permanently delete the promotion, are you sure?</span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">Cancel</el-button>
                <el-button type="danger" @click="deletepromotion()">Yes Delete</el-button>
              </span>
            </el-dialog>
          </el-card>
        </el-col>

        <!-- LIST -->
        <el-col :span="16">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Existing promotions</h4>
              <p class="category">List of existing promotions, you can use the search form above to search for a specific promotion.</p>
              <div style="margin-bottom: 10px">
                <el-row>
                  <el-col :span="6">
                    Filter by Code: <el-input v-model="filters[0].value" placeholder="Enter text to filter..."></el-input>
                  </el-col>
                </el-row>
              </div>
              <br>
            </div>
            <div v-if="error">{{error}}</div>

            <div class="table-responsive">
             
              <data-tables-server 
              class="table-shopping" 
              style="width: 100%" 
              :data="results" 
              :filters="filters" 
              :current-page="1" 
              :total="total"
              :loading="loadingDiscounts"
              @query-change="loadData" 
              :page-size="20"
              :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }">

                <el-table-column
                  label="ID"
                  min-width="70"
                >
                  <template slot-scope="props">{{props.row.id}}</template>
                </el-table-column>
                <el-table-column
                  label="Start Date"
                  min-width="100"
                  sortable="custom"
                  prop="startDate"
                >
                  <template slot-scope="props">
                    <span v-if="props.row.neverEnding != 1">{{props.row.startDate}}</span>
                    <span v-else class="label label-primary">FOREVER</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="End Date"
                  min-width="100"
                  sortable="custom"
                  prop="endDate"
                >
                  <template slot-scope="props">
                    <span v-if="props.row.neverEnding != 1">{{props.row.endDate}}</span>
                    <span v-else class="label label-primary">FOREVER</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Code"
                  min-width="120"
                >
                  <template slot-scope="props">{{props.row.code}}</template>
                </el-table-column>
                <el-table-column
                  label="Description"
                  min-width="250"
                >
                  <template slot-scope="props">{{props.row.description}}</template>
                </el-table-column>
                <el-table-column
                  label="Date Created"
                  min-width="120"
                  sortable="custom"
                  prop="dateCreated"
                >
                  <template slot-scope="props"><span v-if="props.row.dateCreated != null">{{props.row.dateCreated | moment('DD/MM/YYYY')}}</span></template>
                </el-table-column>
                <el-table-column
                  label="Edit"
                  min-width="40"
                >
                  <template slot-scope="props">
                    <router-link :to="'/promotions/edit/'+props.row.id">Edit</router-link>
                  </template>
                </el-table-column>
              </data-tables-server>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import gql from "graphql-tag";
import moment from "moment";
const CREATE_DISCOUNT=gql`
mutation createDiscount($discount: [Discount_insert_input!]!){
  insert_Discount(objects:$discount){
    returning{
      id
    }
    affected_rows
  }
}
`;
const CREATE_SELECTED_CLASSROOM=gql`
mutation createSelectedClassRoom($selectedClassRoom: [Discount_selectedClassRoom_insert_input!]!){
  insert_Discount_selectedClassRoom(objects:$selectedClassRoom){
    returning{
      id
    }
    affected_rows
  }
}
`;
const CREATE_SELECTED_PRODUCT=gql`
mutation createSelectedProduct($selectedProduct: [Discount_selectedProduct_insert_input!]!){
  insert_Discount_selectedProduct(objects:$selectedProduct){
    returning{
      id
    }
    affected_rows
  }
}
`;
export default {
  props: ["property", "value"],

  data() {
    return {
      loadingDiscounts: false,
      loadingClassrooms: false,
      loadingCourses: false,
       paginationDef: {pageSize: 10, pageSizes: [10, 20, 100], currentPage: 1},
      classrooms: [],
      courses: [],
      results: [],
      filters: [
        {
          value: '',
          'search_prop': 'code' // define search_prop for backend usage.
        }
      ],
      discountId: null,
      selectedClassRooms: [],
      selectedProducts: [],
      promotion: {
        'maxUses':0, 
        'totalUses':0, 
        'remainingUses':0, 
        'discountFlat':0, 
        'discountPercentage':0,
        'threshold': 0,
        'allProductPriceLabels': 0
      },
      dialogVisible: false,
      error: null,
      total: 0,
      endFilter: moment().add(1, "weeks").format("YYYY-MM-DD"),
      startFilter: moment().format("YYYY-MM-DD"),
      townFilter: null,
      promotionTypes: [
        "all courses",
        "all courses all downloads",
        "all downloads",
        "all extras",
        "all bundles",
        "classroom and combined courses",
        "classroom courses",
        "classrooms 2 days",
        "classrooms 3 days",
        "classrooms 5 days",
        "combination",
        "combined courses",
        "combined courses and downloads",
        "fixed price",
        "online courses",
        "order",
        "selected classrooms",
        "selected courses",
        "selected downloads",
        "selected extras"
      ],
      calculationTypes: [
        "flat first",
        "percentage first"
      ],
      rules: {
        code: [
          {
            required: true,

            message: "Please input code",
            trigger: "blur"
          }
        ],
        description: [
          {
            required: true,

            message: "Please input description",
            trigger: "blur"
          }
        ],
      },
      searchDef: {
        show: true,
        props: "lastname"
      }
    };
  },

  methods: {
    toggleDialog(id) {
      this.dialogVisible = !this.dialogVisible;
    },

    getClassrooms() {

      this.loadingClassrooms = true;
      var startDate = moment(this.startFilter).format("YYYY-MM-DD");
      var endDate = moment(this.endFilter).format("YYYY-MM-DD");

      this.$apollo
      .query({
        // desc_nulls_last filters out any null data
        query: gql`
          {
            ClassRoom(
              where: { 
                  _and: [
                    { startDate: {_gte: "${startDate}"} },
                    { startDate: {_lte: "${endDate}"} }
                  ]
                }
            ) {
              id
              code
              isPublic
              startDate
              length
              venue {
                town
              }
            }
          }
        `,
        // can get error if needed
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        this.classrooms = response.data.ClassRoom;
        this.loadingClassrooms = false;
      });
    },

    getCourses() {

      this.loadingCourses = true;

      this.$apollo
      .query({
        // desc_nulls_last filters out any null data
        query: gql`
          {
            Product(
              where: { 
                  _or: [
                    { type: {_eq: "online course"} },
                    { type: {_eq: "classroom course"} },
                    { type: {_eq: "combined course"} },
                    { type: {_eq: "bundle"} },
                  ]
                }
            ) {
              id
              name
            }
          }
        `,
        // can get error if needed
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        this.courses = response.data.Product;
        this.loadingCourses = false;
      });
    },
    
    async loadData(queryInfo) {

      this.loadingDiscounts = true;
      console.log(queryInfo)
      if ( queryInfo != undefined ) {

        var type = queryInfo.type;
        var page = queryInfo.page;
        var pageSize = queryInfo.pageSize;
        var orderDir = 'desc_nulls_last';
        var orderProp = 'dateCreated';
        var filterProp = 'code';
        var filterValue = this.$props.value?this.$props.value:'';

        (queryInfo.type === 'page' || queryInfo.type === 'size' || queryInfo.type === 'sort' || queryInfo.type === 'filter') //&&
        //this.$message(`page: ${queryInfo.page}, pageSize: ${queryInfo.pageSize}, prop: ${queryInfo.sort.prop}, order: ${queryInfo.sort.order}, type: ${queryInfo.type}, value: ${queryInfo.filters[0].value}`)

        if(queryInfo.sort){
        if (queryInfo.sort.order === 'ascending') {
          orderDir = 'asc_nulls_last';
        } else if (queryInfo.sort.order === 'descending') {
          orderDir = 'desc_nulls_last';
        }
         if (queryInfo.sort.prop != undefined) {
          orderProp = queryInfo.sort.prop;
        }
        }
        if (queryInfo.type === 'filter') {
          filterProp = queryInfo.filters[0].search_prop;
          filterValue = queryInfo.filters[0].value+'%';
        }
       

      } else {

        var type = 'init';
        var page = 1;
        var pageSize = 20;
        var orderDir = 'desc_nulls_last';
        var orderProp = 'dateCreated';

      }

      console.log('queryinfo: ', queryInfo)
      console.log('loading data...')

      if (filterValue != '') {

      this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          query: gql`
            {
              Discount(
                limit: ${pageSize}, 
                offset: ${(page - 1) * pageSize}, 
                order_by: {${orderProp}: ${orderDir}}, 
                where:{${filterProp}: {_ilike: "${filterValue}"}}
              ) {
                  allProductPriceLabels
                  calculationType
                  code
                  dateCreated
                  dateUpdated
                  description
                  discountFlat
                  discountPercentage
                  endDate
                  id
                  isInfinite
                  maxUses
                  neverEnding
                  productPriceLabel
                  remainingUses
                  startDate
                  threshold
                  totalUses
                  type
                }
                Discount_aggregate(
                  where:{${filterProp}: {_ilike: "${filterValue}"}}
                ) {
                  aggregate {
                    count
                  }
                }
            }
          `,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.results = response.data.Discount;
          this.total = response.data.Discount_aggregate.aggregate.count;
          this.loadingDiscounts = false;
        });
    } else {
        /// It's the list view  ///
        this.$apollo
          .query({
            // desc_nulls_last filters out any null data
            query: gql`
              {
                Discount(
                  limit: ${pageSize}, 
                  offset: ${(page - 1) * pageSize}, 
                  order_by: {${orderProp}: ${orderDir}},
                ) {
                  allProductPriceLabels
                  calculationType
                  code
                  dateCreated
                  dateUpdated
                  description
                  discountFlat
                  discountPercentage
                  endDate
                  id
                  isInfinite
                  maxUses
                  neverEnding
                  productPriceLabel
                  remainingUses
                  startDate
                  threshold
                  totalUses
                  type
                }
                Discount_aggregate{
                  aggregate {
                    count
                  }
                }
            }
            `,
            // can get error if needed
            error(error) {
              this.error = JSON.stringify(error);
            }
          })
          .then(response => {
            this.results = response.data.Discount;
            this.total = response.data.Discount_aggregate.aggregate.count;
            this.loadingDiscounts = false;
          });
      }
    },

    addPromotion() {
      this.promotion.dateCreated=moment().format()
      this.promotion.isInfinite = this.promotion.isInfinite + 0 //change boolean to number
      if (this.promotion.isInfinite == 1) {
        this.promotion.maxUses = 0
      }
      this.promotion.neverEnding = this.promotion.neverEnding + 0 //change boolean to number
      const promotion = this.promotion && this.promotion
      

      this.$apollo.mutate({
        mutation:CREATE_DISCOUNT,
        variables:{
          discount:promotion
        }
      }).then(result => {
        this.discountId = result.data.insert_Discount.returning[0].id
        // Add selectedClassrooms if necessary
        if (this.promotion.type == 'selected classrooms') {
          //console.log('classroom array: ', this.selectedClassRooms);
          for (var i = 0, len = this.selectedClassRooms.length; i < len; i++) {
            this.addClassroom(result.data.insert_Discount.returning[0].id,i)
          }
          this.$notify({
            title: "Success",
            message: "Discount Created",
            type: "success"
          });
          this.$router.push({ path: "/promotions/edit/" + result.data.insert_Discount.returning[0].id });
        }
        // Add selectedProducts if necessary
        else if (this.promotion.type == 'selected courses' || this.promotion.type == 'combination') {
          for (var i = 0, len = this.selectedProducts.length; i < len; i++) {
            this.addCourse(result.data.insert_Discount.returning[0].id,i);
          }
          this.$notify({
            title: "Success",
            message: "Discount Created",
            type: "success"
          });
          this.$router.push({ path: "/promotions/edit/" + result.data.insert_Discount.returning[0].id });
        } 
        else {
          this.$notify({
            title: "Success",
            message: "Discount Created",
            type: "success"
          });
          this.$router.push({ path: "/promotions/edit/" + result.data.insert_Discount.returning[0].id });
        }

      }).catch(error => {
        this.$notify({
          title: "Error",
          message: error.message,
          type: "error"
        });
      });
    },

    addClassroom(discountId,i) {

      var selectedClassRoom = {'discountId':discountId, 'classRoomId': this.selectedClassRooms[i]}
      console.log('selected classroom: ', selectedClassRoom);

      this.$apollo.mutate({
      mutation:CREATE_SELECTED_CLASSROOM,
      variables:{
        selectedClassRoom:selectedClassRoom
      }
      }).then(result => {
        this.$notify({
          title: "Success",
          message: "Selected Classroom Added",
          type: "success"
        });
      }).catch(error => {
        this.$notify({
          title: "Error",
          message: error.message,
          type: "error"
        });
      }) 

    },

    addCourse(discountId,i) {
      
      var selectedProduct = {'discountId':discountId, 'productId': this.selectedProducts[i]}
      console.log('selected product: ', selectedProduct);

      this.$apollo.mutate({
      mutation:CREATE_SELECTED_PRODUCT,
      variables:{
        selectedProduct:selectedProduct
      }
      }).then(result => {
        this.$notify({
          title: "Success",
          message: "Selected Product Added",
          type: "success"
        });
      }).catch(error => {
        this.$notify({
          title: "Error",
          message: error.message,
          type: "error"
        });
      }) 

    }
  },
  watch: {
    "$route.params": function(value) {
         if (value.hasOwnProperty("code")) {
    this.loadData({pageSize:1,page:1});
      }else{
        this.loadData({pageSize:20,page:1})
      }
    
      
    }
  },
  mounted() {

   
    this.getCourses();
    this.getClassrooms();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Promotions/list.vue